import { CHAT_MAX_UPLOAD_FILE_SIZE } from "../session/constants";
import { getGlobalConf } from "../../services/global";
import { ResCode } from "../../constants/request";
import {
  EInvitationSwitch,
  EVerifyUserSwitch,
  ELoginRegisterSwitch,
} from "./types";
import { makeAutoObservable } from "mobx";

class GlobalConf {
  private _verify_user = EVerifyUserSwitch.disabled; // 实名认证开关
  private _invitation = EInvitationSwitch.hidden; // 邀请码开关
  private _menu_hidden: string[] = []; // 隐藏的菜单
  private _login_register = ELoginRegisterSwitch.disabled; // 登录即注册开关
  private _show_moe = false; // moe开关
  private _chat_file_size = 2; // 通用对话文件大小限制，单位MB
  public max_token = 100000;

  constructor() {
    makeAutoObservable(this);
  }

  set verifyUserSwitch(
    val: EVerifyUserSwitch.able | EVerifyUserSwitch.disabled,
  ) {
    this._verify_user = val;
  }

  get verifyUserSwitch() {
    return this._verify_user;
  }

  set invitationSwitch(
    val:
      | EInvitationSwitch.required
      | EInvitationSwitch.optional
      | EInvitationSwitch.hidden,
  ) {
    this._invitation = val;
  }

  get invitationSwitch() {
    return this._invitation;
  }

  set menuHidden(val: string[]) {
    this._menu_hidden = val;
  }

  get menuHidden() {
    return Array.isArray(this._menu_hidden) ? this._menu_hidden : [];
  }

  set loginRegister(val: ELoginRegisterSwitch) {
    this._login_register = val;
  }

  get loginRegister() {
    return this._login_register;
  }

  set showMoeConf(val: boolean) {
    this._show_moe = val;
  }

  get showMoeConf() {
    return this._show_moe;
  }

  set chatFileSize(val: number) {
    this._chat_file_size = val;
  }

  get chatFileSize() {
    return this._chat_file_size;
  }

  async updateGlobalConf() {
    try {
      const confRes = await getGlobalConf();
      if (confRes.code === ResCode.Success) {
        this.invitationSwitch = confRes.message.invitation;
        this.verifyUserSwitch = confRes.message.verify_user;
        this.menuHidden = confRes.message.menu_hidden;
        this.loginRegister = confRes.message.login_register;
        this.max_token = confRes.message.max_token;
        this._chat_file_size =
          confRes.message.file_size || CHAT_MAX_UPLOAD_FILE_SIZE; // TODO: get value from confRes
      } else {
        console.log(Error(JSON.stringify(confRes)));
      }
    } catch (error) {
      console.log(error);
    }
  }
}

export default new GlobalConf();
